// extracted by mini-css-extract-plugin
module.exports = {"container":"product-list_container__VgT7Q","navigation":"product-list_navigation__gtu9B"};